import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./CheckoutPage.css";

const CheckoutPaystackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const paymentReference = searchParams.get("paymentReference");
  const statusFromPaystack = searchParams.get("status"); // success | aborted | failed

  const [loading, setLoading] = useState(true);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("error");

  useEffect(() => {
    if (!paymentReference) return;

    if (statusFromPaystack === "aborted") {
      setAlertMessage("Payment was cancelled");
      setAlertType("error");
    } else if (statusFromPaystack === "success") {
      setAlertMessage("Payment Successful 🎉");
      setAlertType("success");
    } else {
      setAlertMessage("Payment not completed");
      setAlertType("error");
    }

    setLoading(false);
    setAlertVisible(true);
  }, [paymentReference, statusFromPaystack]);

  const handleDismiss = () => {
    setAlertVisible(false);

    if (alertType === "success") {
      navigate("/home/guest", { state: { success: true } });
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="checkout-page">
      {loading && (
        <div className="checkout-loading-overlay">
          <div className="checkout-spinner"></div>
          <p>Verifying payment...</p>
        </div>
      )}

      {alertVisible && (
        <div className="checkout-alert-overlay">
          <div className={`checkout-alert ${alertType}`}>
            <div className="alert-icon">
              {alertType === "success" ? "✓" : "✕"}
            </div>

            <h2>{alertMessage}</h2>

            <div
              className={`alert-actions ${
                alertType !== "success" ? "single-row" : ""
              }`}
            >
              <button onClick={handleDismiss} className="alert-dismiss-button">
                {alertType === "success" ? "Continue" : "Try Again"}
              </button>

              {statusFromPaystack !== "success" && (
                <button
                  onClick={handleDismiss}
                  className="alert-dismiss-button"
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutPaystackPage;
